export default "__VITE_ASSET__CU_BeI8e__"